import { render } from "./UserListItem.vue?vue&type=template&id=1788bae4&scoped=true"
import script from "./UserListItem.vue?vue&type=script&lang=js"
export * from "./UserListItem.vue?vue&type=script&lang=js"

import "./UserListItem.vue?vue&type=style&index=0&id=1788bae4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1788bae4"]])

export default __exports__